export default "__VITE_ASSET__p1Uxb1uN__"